@if (breakpointService.deviceSize$ | async; as deviceSize) {
  <div
    class="navigation"
    [ngClass]="{
      'mobile justify-between': deviceSize.isMobile,
      'dark-mode': (themeService.currentTheme$ | async) === Theme.DARK,
    }"
  >
    @if (deviceSize.isMobile) {
      <div id="sidebar-menu" (click)="toggleSidebar()">
        <img
          alt="Menu"
          width="24"
          height="24"
          [src]="
            isSidebarOpen ? 'assets/glyphs/sidebar/mobile_menu_close.svg' : 'assets/glyphs/sidebar/mobile_menu.svg'
          "
        />
      </div>
    }
    <a href="javascript:void(0);" class="logo-link" routerLink="/">
      @if (navbarService.logoUrl$ | async; as logoUrl) {
        <img alt="Logo" class="nav-logo" [src]="logoUrl" [ngClass]="{ mobile: deviceSize.isMobile }" />
      }
    </a>
    <div class="w-50 profile-section justify-content-end">
      @if (!deviceSize.isMobile) {
        @if (navbarService.globalSearchComponent$ | async; as globalSearchComponent) {
          <div class="w-60">
            <ng-container [ngComponentOutlet]="globalSearchComponent" />
          </div>
        }
      }
      @if (featureFlagsService.ppShowBalanceWallet && configuration?.showWalletGlobally) {
        @if (walletHistory$ | async; as walletHistory) {
          @if (walletHistory.length && walletHistory[0].balanceWallet >= 0) {
            @if (deviceSize.isMobile) {
              <app-prudent-expandable-button
                image="assets/glyphs/new-design/dashboard/wallet-06.svg"
                [title]="getWalletTitle(walletHistory, true)"
              />
            } @else {
              <app-prudent-button
                buttonType="secondary-blue"
                buttonSize="medium"
                classOverrides="fw-light"
                glyph="wallet-03"
                [title]="getWalletTitle(walletHistory)"
                (click)="openWalletDialog()"
              />
            }
          }
        }
      }

      @if (whatsappConfig$ | async; as whatsapp) {
        @if (!deviceSize.isMobile && whatsapp.enabled) {
          <app-prudent-icon-button
            id="instadesk"
            buttonType="secondary-blue"
            buttonSize="medium"
            glyph="whatsapp"
            (click)="openInstaDeskDialog(whatsapp.number, deviceSize.isMobile)"
          />
        }
      }
      <div class="profile-menu">
        <img
          alt="user"
          class="user-img"
          role="button"
          tabindex="0"
          [attr.aria-expanded]="menu"
          [src]="navbarService.selfImage()"
          (click)="toggleMenu()"
          (keydown.enter)="toggleMenu()"
          (keydown.space)="toggleMenu()"
          (clickOutside)="hideMenu()"
        />
        <div class="nav-bar-menu" [ngClass]="{ show: menu }">
          @if (deviceSize.isMobile) {
            @if (whatsappConfig$ | async; as whatsapp) {
              @if (whatsapp.enabled) {
                <a
                  class="border-bottom"
                  id="instadesk"
                  (click)="openInstaDeskDialog(whatsapp.number, deviceSize.isMobile)"
                >
                  <img
                    height="16"
                    width="16"
                    alt="WhatsApp"
                    class="glyph-primary-filter"
                    src="assets/glyphs/black/whatsapp.svg"
                  />&nbsp; InstaDesk
                </a>
              }
            }
          }
          @if (!deviceSize.isMobile && navbarService.downloadApp) {
            <a class="border-bottom" id="instadesk" (click)="openDownloadDialog()">
              <img
                height="16"
                width="16"
                alt="WhatsApp"
                class="glyph-primary-filter"
                src="assets/glyphs/black/download-circle.svg"
              />&nbsp; Download App
            </a>
          }
          @for (item of items; track item) {
            <a href="javascript:void(0);" class="border-bottom" [routerLink]="item.link">
              <img
                height="16"
                width="16"
                class="glyph-primary-filter me-x-small"
                [alt]="item.title"
                [src]="item.image"
              />
              {{ item.title }}
            </a>
          }
          <a href="javascript:void(0);" class="border-bottom" (click)="showPrivacyPolicy()">
            <img
              alt="privacy-policy"
              src="assets/glyphs/black/permission.svg"
              class="glyph-primary-filter me-x-small"
              height="16"
              width="16"
            />Privacy Policy
          </a>
          @if (canSeeLastYearPolicy) {
            @if (allPolicies$ | async; as allPolicies) {
              @if (allPolicies.length > 1) {
                <a href="javascript:void(0);" class="border-bottom" (click)="viewPreviousYearPolicy(allPolicies)">
                  <img
                    alt="previous-year-policy"
                    src="assets/glyphs/black/previous-policy.svg"
                    class="glyph-primary-filter me-x-small"
                    height="16"
                    width="16"
                  />View Previous Year Policy
                </a>
              }
            }
          }
          <a
            href="javascript:void(0);"
            class="border-bottom"
            (click)="themeService.updateTheme((themeService.currentTheme + 1) % 3)"
          >
            <img
              alt="theme-icon"
              src="assets/glyphs/black/highlight-true.svg"
              class="glyph-primary-filter me-x-small"
              height="16"
              width="16"
            />Current Theme - {{ ThemeHelpers.describe(themeService.currentTheme) }}
          </a>
          @if (allowExplicitLogout) {
            <a href="javascript:void(0);" (click)="authenticationService.logout()">
              <img
                alt="Logout"
                src="assets/glyphs/black/logout.svg"
                class="glyph-primary-filter me-x-small"
                height="16"
                width="16"
              />Logout
            </a>
          }
        </div>
      </div>
    </div>
  </div>
  @if (environmentService.upcomingServiceWindow) {
    <h1 class="f-12 bg-warning-50 w-100 service-outage-banner d-flex align-items-center px-small">
      {{ environmentService.serviceOutageMessage }}
    </h1>
  }
}
